import axios from "axios";
import React, { useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { subscriptionsMigrationsListColumns } from "./constants";

export const SubscriptionMigration = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [filter, setFilter] = useState("");

  const subHeaderComponentMemo = useMemo(() => {
    return (
      <input
        id="search"
        type="text"
        placeholder="Filtro"
        className="form-control"
        style={{ width: "200px" }}
        value={filter}
        onChange={e => setFilter(e.target.value)}
      />
    );
  }, [filter]);

  const handleChangeRowsPerPageChange = (rowsPerPage) => {
    setPage(1);
    setPerPage(rowsPerPage);
  };
  
  const handlePageChange = (page) => {
    setPage(page);
  };

  useEffect(() => {
    const loadMigrations = async () => {
      setIsLoading(true);
      try {
        const BASE_URL = `${process.env.REACT_APP_API_URL}/subscription/schedule-migration/all`;
        const response = await axios.get(`${BASE_URL}?page=${page}&per_page=${perPage}&filter=${filter}`);

        if (!response.data.success) {
          toast.error("Houve um erro inesperado ao carregar as migrações. Tente novamente.");
          return;
        }
        setData(response.data.data.rows);
        setTotalRows(response.data.data.count);
      } catch (error) {
        toast.error("Tivemos um problema ao carregar as migrações.");
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    loadMigrations();
  }, [filter, perPage, page]);

  return (
    <>
      <h1 className="azul-cabecalho">Migração de Planos</h1>
      <p className="subheader-text mb-10">
        Listagem das migrações pendentes
      </p>
      <Link to="/subscription_migration/add">
        <button
          type="button"
          className="btn btn-icon btn-primary mb-10"
          style={{ width: "200px" }}
        >
          <i className="flaticon2-add pr-2" />Nova Migração
        </button>
      </Link>
      <div className="row mb-10">
        <div style={{ overflowX: "auto", width: "100%" }}>
          <DataTable
            columns={subscriptionsMigrationsListColumns}
            data={data}
            progressPending={isLoading}
            pagination
            perPage={perPage}
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handleChangeRowsPerPageChange}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={subHeaderComponentMemo}
          />
        </div>
      </div>
    </>
  );
};
